export default __webpack_public_path__ + "static/media/filter.fc035691.svg";